import React, { useCallback, useState } from 'react';
import useFileUpload from '../../hooks/useFileUpload';
import Button from '../Button/Button';
import { Box } from 'rebass';
import { gql, useMutation } from '@apollo/client';
import useNotify from '../../hooks/useNotify';
import { useUploadTempFile } from '../../hooks/useUploadTempFile';

const ADD_JOB_ATTACHMENT = gql`
  mutation AddJobAttachment(
    $jobId: ID!
    $tempKey: String!
    $contentType: String!
  ) {
    addJobAttachment(
      jobId: $jobId
      tempKey: $tempKey
      contentType: $contentType
    ) {
      id
    }
  }
`;

type JobPhotosEditProps = {
  jobId: string;
  onPhotosAdded?: (() => void) | (() => Promise<any>);
};

const accept = {
  'image/*': ['.jpg', '.jpeg', '.png', '.webp'],
};

const JobPhotosEdit: React.FC<JobPhotosEditProps> = ({
  jobId,
  onPhotosAdded,
}) => {
  const [addJobAttachment] = useMutation<
    { addJobAttachment: { id: string } },
    { jobId: string; tempKey: string; contentType: string }
  >(ADD_JOB_ATTACHMENT, {
    onError: (error) => {
      showError('Error attaching photo to job', error);
    },
  });

  const [uploading, setUploading] = useState<boolean>(false);

  const { uploadTempFiles } = useUploadTempFile();

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      try {
        setUploading(true);
        const uploadResults = await uploadTempFiles(acceptedFiles);

        const promises = uploadResults.map((tempFile) => {
          return addJobAttachment({
            variables: {
              jobId,
              contentType: tempFile.contentType,
              tempKey: tempFile.key,
            },
          });
        });

        await Promise.all(promises);
        onPhotosAdded?.();
      } catch (e) {
        showError('Error uploading files', e as Error);
      } finally {
        setUploading(false);
      }
    },
    [uploadTempFiles]
  );

  const { getRootProps, getInputProps } = useFileUpload({
    multiple: true,
    accept,
    onDrop,
    disabled: uploading,
  });
  const { showError } = useNotify();

  return (
    <>
      <Box flexShrink={0} flexGrow={0} {...(getRootProps() as any)}>
        <input {...getInputProps()} />
        <Button icon="image" variant="secondary" disabled={uploading}>
          {uploading ? 'Uploading...' : 'Select...'}
        </Button>
      </Box>
      {/*<UploadDrop icon="image" multiple accept={accept} dropZone={dropZone} />*/}
    </>
  );
};

export default JobPhotosEdit;
